import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import store from "../index";
// Login Redux States
import {
  CHANGE_PIN,
  LOGIN_USER,
  LOGOUT_USER,
  REGISTER_USER,
  UPDATE_PROFILE,
} from "./actionTypes";
import { apiError, loginSuccess, logoutUserSuccess } from "./actions";
//Include Both Helper File with needed methods
import {
  storeTokenToLocalStorage,
  deleteTokenFromLocalStorage,
  storeUserToLocalStorage,
  storeAuthSession,
} from "../../helpers/utils";
import {
  updateUserApiCall,
  logoutApiCall,
  postLogin,
  registerApiCall,
  armRefreshTimerFromLogin,
} from "../../helpers/repository";
import { showMessage } from "../../components/Common/Toaster";
import { setActiveFooterTab, setActiveTab } from "../actions";
import { getAllLeagues } from "../Leagues/actions";
import { getAllLocations } from "../Locations/actions";
import { getAllSports } from "../Sports/actions";
import { getAllProducts } from "../Products/actions";

function* loginUser({ payload: { user, history } }) {
  try {
    const response = yield call(postLogin, {
      phone_number: user?.phone_number,
      password: user?.password,
      fcm_token: user?.fcm_token,
    });

     storeAuthSession(response.data);
  armRefreshTimerFromLogin(response?.data?.expires_in);

    storeUserToLocalStorage(response.data);
    yield put(loginSuccess(response.data));
    yield put(apiError(""));

    // Quick-continue caches for the login screen (parity with mobile).
    // Kept outside the auth keys so they survive logout when "remember me" is on.
    try {
      if (localStorage.getItem("login:remember_me") !== "false") {
        const u = response?.data?.user ?? {};
        if (u.first_name) localStorage.setItem("login:last_first_name", u.first_name);
        if (u.phone_number) localStorage.setItem("login:last_phone", String(u.phone_number));
        if (u.cash_balance != null) localStorage.setItem("login:last_balance", String(u.cash_balance));
        if (u.open_bets != null) localStorage.setItem("login:last_open_bets", String(u.open_bets));
      }
    } catch (e) { /* cache best-effort */ }

    // Resume the interrupted action if a guard stored one (parity with mobile redirectTo)
    const redirectTo = sessionStorage.getItem("redirect_after_login");
    sessionStorage.removeItem("redirect_after_login");
    history.push(redirectTo || "/sports");
    showMessage("success", `welcome ${response?.data?.user?.phone_number}`);
    store.dispatch(setActiveTab("home-upcoming"));
    store.dispatch(setActiveFooterTab("home"));
    yield store.dispatch(getAllLeagues());
    yield store.dispatch(getAllLocations());
    yield store.dispatch(getAllSports());
  } catch (error) {
    yield put(apiError(error.response.data.errors));
    // history.push("/login")
  }
}

function* registerUser({ payload: { user, history }, cb }) {
  try {
    const response = yield call(registerApiCall, {
      phone_number: user?.phone_number,
      password: user?.password,
      // Omit the key entirely (JSON.stringify drops undefined) when no ref
      // was supplied — the API rejects registration with "Ref ID Prohibited"
      // if ref_id is present at all (even null/"") on a referral-less signup.
      ref_id: user?.ref_id || undefined,
      code: user?.code,
      pin: user?.pin,
      type: user?.type,
      email: user?.email,
      referral_source: user?.referral_source,
      referred_by_code: user?.referred_by_code,
      date_of_birth: user?.date_of_birth
    });
    cb(response.data.message);
  } catch (error) {
    yield put(apiError(error.response.data.errors));
    // history.push("/login")
  }
}

function* attemptChangePin(action) {
  const {
    payload: { password },
  } = action;
  try {
    const response = yield call(updateUserApiCall, { password: password });
    showMessage("success", response.data.message);
  } catch (error) {
    yield put(apiError(error?.response?.data?.errors));
  }
}

function* attemptUpdateProfile(action) {
  // const {
  //   payload: { first_name, last_name, email, nrc_number, id_card },
  // } = action.payload;
  const { payload, onSuccess, onError } = action;

  try {
    const response = yield call(updateUserApiCall, payload);
    if (typeof onSuccess === "function") {
      onSuccess(response);
    }
    // const response = yield call(updateUserApiCall, {
    //   first_name: first_name,
    //   last_name: last_name,
    //   email: email,
    //   nrc_number: nrc_number,
    //   id_card: id_card,
    // });
    // showMessage("success", response.data.message);
  } catch (error) {
    if (typeof onError === "function") {
      onError(error);
    }
    yield put(apiError(error?.response?.data?.errors));
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    const response = yield call(logoutApiCall);
    yield put(logoutUserSuccess(response));
  } catch (error) {
    yield put(apiError(error));
  } finally {
    deleteTokenFromLocalStorage();
    localStorage.removeItem("user");
    history.push("/login");
    yield showMessage("success", `Bye for now`);
    yield store.dispatch({
      type: "RESET",
    });
    yield store.dispatch(getAllLeagues());
    yield store.dispatch(getAllLocations());
    yield store.dispatch(getAllSports());
    yield store.dispatch(getAllProducts());
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeEvery(LOGOUT_USER, logoutUser);
  yield takeEvery(REGISTER_USER, registerUser);
  yield takeEvery(CHANGE_PIN, attemptChangePin);
  yield takeEvery(UPDATE_PROFILE, attemptUpdateProfile);
}

export default authSaga;
